import { Ref } from 'vue';
import { filterListToOptions } from '@/ui/helpers';
import { EntityFolderEdit, EntityFolder } from '@/entities/entityFolder';
import {
  availableEntityFolderDefaultQuery,
  AvailableEntityFolderTypes,
  listAvailable as fetchAvailableEntityFolders,
} from '@/services/api/resources/entityFolder';
import { useTask } from '@/ui/concerns';

export const prepareExcluded = (id: number|null, record: Ref<EntityFolderEdit|EntityFolder>) => {
  const excluded = id ? [id] : [];

  if (record.value.parents) {
    excluded.concat(record.value.parents);
  }

  return excluded;
};

export const fetchSelectOptions = (id: number|null, childrenOptions: Ref, queryData: Ref<EntityFolderEdit|EntityFolder>) => useTask(
  () => {
    const childQuery = availableEntityFolderDefaultQuery(AvailableEntityFolderTypes.CHILD);
    childQuery.excluded = prepareExcluded(id, queryData);
    childQuery.currentEntityFolderId = id;

    return fetchAvailableEntityFolders(childQuery);
  },
  childEntityFolders => {
    childrenOptions.value = filterListToOptions(childEntityFolders);
  },
);
